// Module
var code = "<md-toast role=\"alert\"> <span class=\"md-toast-text\" flex translate translate-values=\"{{ toasterCtrl.values }}\"> {{ toasterCtrl.message }} </span> <md-button ng-if=\"!toasterCtrl.hideCloseButton\" ng-click=\"toasterCtrl.closeToast()\"> <span translate>fermer</span> </md-button> </md-toast> ";
// Exports
module.exports = code;